import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Star, Sparkles, MapPin } from "lucide-react";

export default function FeaturedStrip() {
  const [pros, setPros] = useState([]);

  useEffect(() => {
    api.get("/contractors/featured/list").then(({ data }) => setPros(data)).catch(() => {});
  }, []);

  if (pros.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-5 lg:px-10 py-16">
      <div className="flex items-end justify-between mb-8">
        <div>
          <div className="overline text-[#B85C47] mb-3 flex items-center gap-2">
            <Sparkles className="w-3 h-3" /> Featured this week
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight" style={{ fontFamily: "Outfit" }}>Pros worth a look</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {pros.slice(0, 3).map((c, i) => (
          <Link
            key={c.user_id}
            to={`/contractors/${c.user_id}`}
            data-testid={`featured-card-${c.user_id}`}
            className="bg-white border-2 border-[#B85C47]/40 rounded-xl overflow-hidden hover:-translate-y-1 hover:shadow-md transition-all fade-up"
            style={{ animationDelay: `${i * 40}ms` }}
          >
            <div className="h-40 wood-grain relative">
              {c.cover_image && <img src={c.cover_image} alt="" className="w-full h-full object-cover" />}
              <div className="absolute top-3 left-3 px-2.5 py-1 bg-[#B85C47] text-white rounded-full text-[10px] uppercase tracking-[0.15em] font-bold flex items-center gap-1">
                <Sparkles className="w-3 h-3" /> Featured
              </div>
            </div>
            <div className="p-5">
              <div className="overline text-[#314A3E] mb-1">{c.category}</div>
              <h3 className="font-semibold text-lg tracking-tight" style={{ fontFamily: "Outfit" }}>{c.business_name}</h3>
              <div className="flex items-center gap-1 text-xs text-stone-500 mt-1"><MapPin className="w-3 h-3" /> {c.location}</div>
              <div className="flex items-center gap-1 mt-3">
                <Star className="w-3.5 h-3.5 fill-[#B85C47] text-[#B85C47]" />
                <span className="text-sm font-semibold">{c.avg_rating || "—"}</span>
                <span className="text-xs text-stone-400">({c.review_count})</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
